import LabelField from '@app/components/atoms/LabelField/LabelField'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const CustomEditor = styled('div')`
  .ck .ck-editor__main > .ck-editor__editable {
    min-height: 150px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
`

const TermAndConditionSection = ({ control, setValue, getValues }) => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.DESCRIPTION')}>
          <Controller
            control={control}
            name="description"
            render={() => (
              <CustomEditor>
                <CKEditor
                  data={getValues('description')}
                  editor={ClassicEditor}
                  id="description"
                  name="description"
                  onChange={(value, editor) => setValue('description', editor.getData())}
                />
              </CustomEditor>
            )}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.HOW_TO_USE')}>
          <Controller
            control={control}
            name="how_to_use"
            render={() => (
              <CustomEditor>
                <CKEditor
                  data={getValues('how_to_use')}
                  editor={ClassicEditor}
                  id="how_to_use"
                  name="how_to_use"
                  onChange={(value, editor) => setValue('how_to_use', editor.getData())}
                />
              </CustomEditor>
            )}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.CONDITION')}>
          <Controller
            control={control}
            name="condition"
            render={() => (
              <CustomEditor>
                <CKEditor
                  data={getValues('condition')}
                  editor={ClassicEditor}
                  id="condition"
                  name="condition"
                  onChange={(value, editor) => setValue('condition', editor.getData())}
                />
              </CustomEditor>
            )}
          />
        </LabelField>
      </Grid>

      <Grid item xs={12}>
        <LabelField title={t('VOUCHER.TERM')}>
          <Controller
            control={control}
            name="term"
            render={() => (
              <CustomEditor>
                <CKEditor
                  data={getValues('term')}
                  editor={ClassicEditor}
                  id="term"
                  name="term"
                  onChange={(value, editor) => setValue('term', editor.getData())}
                />
              </CustomEditor>
            )}
          />
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default TermAndConditionSection
